export const contact = {
label: 'Contact',
title: 'Corporate Office',
subtitle: 'Connect with our team for business inquiries, partnership opportunities, and corporate information.',
address_title: 'Office Address',
address: 'ONE MORE GLOBAL INC.\n8556 KATY FREEWAY, SUITE 120\nHOUSTON, TX 77024',
form_title: 'Send an Inquiry',
name: 'Full Name',
name_placeholder: 'Enter your full name',
email: 'Email Address',
email_placeholder: 'Enter your email address',
company: 'Company / Organization',
company_placeholder: 'Enter your company name',
country: 'Country / Region',
country_placeholder: 'Enter your country or region',
category: 'Inquiry Category',
category_placeholder: 'Select a category',
categories: {
  business_development: 'Business Development',
  distribution: 'Distribution Partnerships',
  partnership: 'Strategic Partnerships',
  compliance: 'Compliance & Regulatory',
  media: 'Media & Press',
  careers: 'Careers',
  general: 'General Inquiry',
},
message: 'Message',
message_placeholder: 'Describe your inquiry...',
consent: 'I consent to the processing of my personal data in accordance with the Privacy Policy.',
submit: 'Submit Inquiry',
submitting: 'Submitting...',
success: 'Thank you for your inquiry. We will get back to you shortly.',
error: 'Failed to submit your inquiry. Please try again later.',
};
